// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-change-view-___change-view__change-view___zALns {
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
}

.src-components-change-view-___change-view__actions___BCM6Y {
  border-bottom: 1px solid var(--gray-lighter);
  border-top: 1px solid var(--gray-lighter);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 1em 0 0.5em 0;
}

.src-components-change-view-___change-view__action-btn___dGaKq {
  border: none;
  padding: 0;
  vertical-align: baseline;
}

.src-components-change-view-___change-view__actions-section___n1xt5 {
  padding: 0.7em 0.2em;
  flex: 0 0 auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/change-view/change-view.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,yCAAyC;EACzC,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB","sourcesContent":[".change-view {\n  display: flex;\n  flex: 1 0 auto;\n  flex-direction: column;\n}\n\n.actions {\n  border-bottom: 1px solid var(--gray-lighter);\n  border-top: 1px solid var(--gray-lighter);\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin: 1em 0 0.5em 0;\n}\n\n.action-btn {\n  border: none;\n  padding: 0;\n  vertical-align: baseline;\n}\n\n.actions-section {\n  padding: 0.7em 0.2em;\n  flex: 0 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"change-view": `src-components-change-view-___change-view__change-view___zALns`,
	"changeView": `src-components-change-view-___change-view__change-view___zALns`,
	"actions": `src-components-change-view-___change-view__actions___BCM6Y`,
	"action-btn": `src-components-change-view-___change-view__action-btn___dGaKq`,
	"actionBtn": `src-components-change-view-___change-view__action-btn___dGaKq`,
	"actions-section": `src-components-change-view-___change-view__actions-section___n1xt5`,
	"actionsSection": `src-components-change-view-___change-view__actions-section___n1xt5`
};
export default ___CSS_LOADER_EXPORT___;
